<template>
	<div class="wrapper">
		<Header />
		<side-bar v-if="$store.state.authentication.user_role == 'super-admin'">
			<sidebar-link to="/my_profile">
				<md-icon>assignment_ind</md-icon>
				<p>{{translate(locale.myProfile)}}</p>
			</sidebar-link>
			
			<div style="margin: 10px 0 10px 15px; height: 1px; width: calc(100% - 30px);background-color: rgba(180, 180, 180, 0.3);"></div>
			<sidebar-link to="/products_and_services">
				<md-icon>inventory_2</md-icon>
				<p>{{translate(locale.productServices)}}</p>
			</sidebar-link>
			<sidebar-link to="/quotation_and_bidding">
				<md-icon>campaign</md-icon>
				<p>{{translate(locale.requestQuotation)}}</p>
			</sidebar-link>
			<sidebar-link to="/job_recruitment">
				<md-icon>work</md-icon>
				<p>{{translate(locale.jobRecruitment)}}</p>
			</sidebar-link>
			<sidebar-link to="/scholarship">
				<md-icon>school</md-icon>
				<p>{{translate(locale.scholarshipOffer)}}</p>
			</sidebar-link>
			<div style="margin: 10px 0 10px 15px; height: 1px; width: calc(100% - 30px);background-color: rgba(180, 180, 180, 0.3);"></div>
			<sidebar-link to="/profile_information">
				<md-icon>edit_square</md-icon>
				<p>{{translate(locale.profileInformation)}}</p>
			</sidebar-link>
			<sidebar-link to="/my_activities">
				<md-icon>emoji_events</md-icon>
				<p>{{translate(locale.profileActivity)}}</p>
			</sidebar-link>
			<sidebar-link to="/my_managers">
				<md-icon>manage_accounts</md-icon>
				<p>{{translate(locale.profileManager)}}</p>
			</sidebar-link>
		</side-bar>

		

		<div class="main-panel" style="top:80px">
			
			<!-- <top-navbar></top-navbar> -->
			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'
	import Header from '../../components/Header.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter,
			Header
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue